export const initContact = (): void => {
  const submitBtn = document.getElementById('submit-btn');
  const feedbackContainer = document.getElementById('form-feedback');

  const nameInput = document.getElementById('form-name') as HTMLInputElement | null;
  const businessInput = document.getElementById('form-business') as HTMLInputElement | null;
  const typeSelect = document.getElementById('form-type') as HTMLSelectElement | null;
  const phoneInput = document.getElementById('form-phone') as HTMLInputElement | null;
  const messageInput = document.getElementById('form-message') as HTMLTextAreaElement | null;

  if (!submitBtn || !feedbackContainer) return;

  const inputs = [
    { element: nameInput, name: 'Nombre' },
    { element: businessInput, name: 'Negocio' },
    { element: typeSelect, name: 'Tipo de Negocio' },
    { element: phoneInput, name: 'WhatsApp' },
    { element: messageInput, name: 'Mensaje' }
  ];

  // Helper to clear error state on focus
  inputs.forEach(inputObj => {
    if (inputObj.element) {
      inputObj.element.addEventListener('focus', () => {
        inputObj.element?.classList.remove('border-error');
      });
      inputObj.element.addEventListener('input', () => {
        inputObj.element?.classList.remove('border-error');
      });
    }
  });

  submitBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    // Reset feedback
    feedbackContainer.innerHTML = '';
    feedbackContainer.className = 'hidden';

    // 1. Validation
    let hasError = false;
    inputs.forEach(inputObj => {
      if (inputObj.element) {
        const val = inputObj.element.value.trim();
        if (!val || (inputObj.element.id === 'form-type' && val === '')) {
          inputObj.element.classList.add('border-error');
          hasError = true;
        } else {
          inputObj.element.classList.remove('border-error');
        }
      }
    });

    if (hasError) {
      showFeedback('Por favor, completa todos los campos obligatorios.', 'error');
      return;
    }

    // 2. Set loading state
    const originalBtnText = submitBtn.innerHTML;
    submitBtn.setAttribute('disabled', 'true');
    submitBtn.classList.add('opacity-70', 'cursor-not-allowed');
    submitBtn.innerHTML = `
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-maroon-900 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Enviando solicitud...
    `;

    // 3. Perform POST Request to FormSubmit.co
    try {
      const response = await fetch('https://formsubmit.co/ajax/info@gastroclick.pe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          Nombre: nameInput?.value.trim(),
          Negocio: businessInput?.value.trim(),
          TipoNegocio: typeSelect?.value,
          WhatsApp: phoneInput?.value.trim(),
          Mensaje: messageInput?.value.trim()
        })
      });

      const data = await response.json();

      if (response.ok && data.success === 'true') {
        showFeedback('¡Solicitud enviada con éxito! Nos contactaremos contigo por WhatsApp a la brevedad.', 'success');
        // Clear all fields
        inputs.forEach(inputObj => {
          if (inputObj.element) {
            inputObj.element.value = '';
          }
        });
      } else {
        showFeedback(data.message || 'Hubo un error al enviar el formulario. Por favor, inténtalo de nuevo.', 'error');
      }
    } catch (err) {
      console.error('Submission error:', err);
      showFeedback('No pudimos conectar con el servidor. Revisa tu conexión e inténtalo más tarde.', 'error');
    } finally {
      // Restore button state
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('opacity-70', 'cursor-not-allowed');
      submitBtn.innerHTML = originalBtnText;
    }
  });

  function showFeedback(msg: string, type: 'success' | 'error') {
    if (!feedbackContainer) return;
    feedbackContainer.innerHTML = '';
    
    const alertDiv = document.createElement('div');
    alertDiv.className = `p-4 rounded-md text-sm font-sans flex items-start gap-3 border ${
      type === 'success' 
        ? 'bg-green-50 border-green-200 text-green-800' 
        : 'bg-red-50 border-red-200 text-red-800'
    }`;

    const icon = type === 'success' 
      ? '<span class="text-green-600 text-base">✓</span>' 
      : '<span class="text-red-600 text-base">⚠</span>';

    alertDiv.innerHTML = `
      <div class="flex-shrink-0 font-bold">${icon}</div>
      <div class="flex-grow">${msg}</div>
    `;

    feedbackContainer.appendChild(alertDiv);
    feedbackContainer.classList.remove('hidden');
    
    // Auto-scroll feedback into view smoothly
    feedbackContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
};
